import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
/* Views */
import MySavingsPortfolio from '@/views/savings/mySavings/Portfolio'
import MySavingsChargeDP from '@/views/savings/mySavings/ChargeDP'
import SavingsProductsList from '@/views/savings/products/ProductsList'
import SavingsProductsConstitute from '@/views/savings/products/Constitute'
import HistoryPortfolio from '@/views/savings/history/Portfolio'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.SAVINGS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ***********************************************
*                    MY SAVINGS                  *
*********************************************** */
{
	path: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME,
	component: MySavingsPortfolio
}, {
	path: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE_NAME,
	props: true,
	component: MySavingsChargeDP,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME)
	}
}, {
	path: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE_NAME,
	props: true,
	component: UnderDevelopment,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME)
	}
}, {
	path: routeList.SAVINGS_MY_SAVINGS_PIGGY_BANK_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PIGGY_BANK_NAME,
	component: UnderDevelopment
},
/* ***********************************************
*                     PRODUCTS                   *
*********************************************** */
{
	path: routeList.SAVINGS_PRODUCTS_PATH,
	name: routeList.SAVINGS_PRODUCTS_NAME,
	component: SavingsProductsList
}, {
	path: routeList.SAVINGS_PRODUCTS_CONSTITUTE_PATH,
	name: routeList.SAVINGS_PRODUCTS_CONSTITUTE_NAME,
	props: true,
	component: SavingsProductsConstitute,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.SAVINGS_PRODUCTS_NAME)
	}
},
/* ***********************************************
*                      HISTORY                   *
*********************************************** */
{
	path: routeList.SAVINGS_HISTORY_PATH,
	name: routeList.SAVINGS_HISTORY_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.SAVINGS_HISTORY_PORTFOLIO_PATH,
	name: routeList.SAVINGS_HISTORY_PORTFOLIO_NAME,
	component: HistoryPortfolio
}, {
	path: routeList.SAVINGS_HISTORY_OBJECTIVES_PATH,
	name: routeList.SAVINGS_HISTORY_OBJECTIVES_NAME,
	component: UnderDevelopment
}]
